import React from 'react';

export function BarChart() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M15.0008 11.6H14.8508V4.325C14.8508 3.75 14.3758 3.25 13.7758 3.25H12.4258C11.8508 3.25 11.3508 3.725 11.3508 4.325V11.6H9.75078V5.725C9.75078 5.15 9.27578 4.65 8.67578 4.65H7.32578C6.75078 4.65 6.25078 5.125 6.25078 5.725V11.6H4.62578V7.35C4.62578 6.775 4.15078 6.275 3.55078 6.275H2.20078C1.62578 6.275 1.12578 6.75 1.12578 7.35V11.6H1.00078C0.700781 11.6 0.425781 11.85 0.425781 12.175C0.425781 12.5 0.675781 12.75 1.00078 12.75H15.0008C15.3008 12.75 15.5758 12.5 15.5758 12.175C15.5758 11.85 15.3008 11.6 15.0008 11.6ZM2.27578 11.6V7.425H3.50078V11.6H2.27578ZM7.37578 11.6V5.8H8.60078V11.6H7.37578ZM12.5008 11.6V4.4H13.7258V11.6H12.5008Z"
        fill="#4B5563"
      />
    </svg>
  );
}
